import React from 'react';
import Navbar from '../../components/Navbar';
import DICOMEdit from '../../components/DICOM/DICOMEdit';
import './DICOMEditPage.css';

const DICOMEditPage = () => {
  return (
    <div className="dicom-edit-page">
      <Navbar />
      <div className="dicom-edit-content">
        <h2>Edit XA DICOM</h2>
        <DICOMEdit />
      </div>
    </div>
  );
};

export default DICOMEditPage;
